// DESKTOP NAVIGATION
// desktop function that toggles every menu with children
(() => {
    const gallerySizes = Array.from(document.querySelectorAll('.product-gallery__size'));

    const productSlider = () => {
        if (!document.querySelector('.product-slider__carousel')) {
            return;
        }

        var productSliderFlickity = jQuery('.product-slider__carousel').flickity({
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            groupCells: true,
            draggable: true,
            wrapAround: true,
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 60, y2: 40,
                x3: 20
            }
        });


        var flkty = productSliderFlickity.data('flickity');
        const productSlider = document.querySelector('.product-slider');

        var previousButton = productSlider.querySelector('.button--previous');
        previousButton.addEventListener('click', function () {
            productSliderFlickity.flickity('previous');
        });

        var nextButton = productSlider.querySelector('.button--next');
        nextButton.addEventListener('click', function () {
            productSliderFlickity.flickity('next');
        });

        var productSliderLength = flkty.slides.length;
        productSliderFlickity.on('select.flickity', function (event, index) {
            if (index === 0) {
                previousButton.classList.add('hidden');
                nextButton.classList.remove('hidden');
            } else if (index === productSliderLength - 1) {
                previousButton.classList.remove('hidden');
                nextButton.classList.add('hidden');
            }
        });

        const productItems = Array.from(document.querySelectorAll('.product-item'));
        if (productItems.every(child => child.classList.contains("is-selected"))) {
            productSlider.querySelector('.product-slider__custom-arrows').classList.add('hide');
        } else {
            productSlider.querySelector('.product-slider__custom-arrows').classList.remove('hide');
        }

    };

    const homeMenuOverlay = () => {
        if (!document.querySelector('.navigation')) {
            return;
        }

        Array.from(document.querySelectorAll('.navigation__item[data-target-overlay]')).forEach(element => element.addEventListener('mouseenter', homeOverlayToggle));

        document.querySelector('.navigation').addEventListener('mouseleave', hideOverlay);
    }

    const homeOverlayToggle = () => {
        const {target: element} = event

        Array.from(document.querySelectorAll('.navigation__overlay')).forEach(element => element.classList.remove('navigation__overlay--active'));
        let targetOverlay = document.querySelector(`[data-overlay="${element.dataset.targetOverlay}"]`)
        let navigation = document.querySelector('.navigation');
        if (targetOverlay) {
            targetOverlay.classList.add('navigation__overlay--active');
        }
        if (navigation) {
            navigation.classList.add('navigation--has-overlay');
        }
    }

    const hideOverlay = () => {
        Array.from(document.querySelectorAll('.navigation__overlay')).forEach(element => element.classList.remove('navigation__overlay--active'));
        let navigation = document.querySelector('.navigation');
        if (navigation) {
            navigation.classList.remove('navigation--has-overlay');
        }
    }

    const mobileNavigationSetup = () => {
        if (!document.querySelector('.navigation__item--toggle')) {
            return;
        }

        document.querySelector('.navigation__item--toggle').addEventListener('click', showMobileNavigation);
        Array.from(document.querySelectorAll('.navigation__data-nav-trigger')).forEach(element => element.addEventListener('click', mobileNavigationLinkClick));
        Array.from(document.querySelectorAll('.navigation__main-links li.nav-back')).forEach(element => element.addEventListener('click', mobileNavigationGoBack));
    }

    const showMobileNavigation = () => {
        document.querySelector('.navigation__outer-mobile').classList.toggle('navigation__outer-mobile--active');
        document.querySelector('.navigation__item--toggle').classList.toggle('navigation__item--active');

        document.querySelector('.navigation__outer-mobile').classList.contains('navigation__outer-mobile--active')
            ? document.body.classList.add('stop-scroll')
            : document.body.classList.remove('stop-scroll');
    }

    const mobileNavigationLinkClick = () => {
        const {target: clickedElement} = event;
        if (!clickedElement.dataset.nav) {
            return;
        }

        document.querySelector(`.navigation__main-links--sublinks[data-nav-triggered="${clickedElement.dataset.nav}"]`).classList.add('active');
    }

    const mobileNavigationGoBack = () => {
        const {target: clickedElement} = event;
        clickedElement.parentElement.classList.remove('active');
    }

    const scrollNavigation = () => {
        if (!document.querySelector('.navigation')) {
            return;
        }

        if (window.scrollY > 128) {
            document.querySelector('.navigation').classList.add('navigation--is-scrolling');
            document.querySelector('main').classList.add('is-scrolling');
            return;
        }

        document.querySelector('.navigation').classList.remove('navigation--is-scrolling');
        document.querySelector('main').classList.remove('is-scrolling');
    }

    const productGalleryDropdown = () => {
        if (!document.querySelector('.product-gallery__dropdown-item')) {
            return;
        }

        var acc = document.getElementsByClassName("product-gallery__dropdown-item");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                    panel.style.marginBottom = null;
                    panel.style.marginTop = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                    panel.style.marginBottom = 60 + "px";
                    panel.style.marginTop = 20 + "px";
                }
            });
        }
        for (i = 0; i < 1; i++) {
            acc[i].classList.toggle("active");
            var panel = acc[i].nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                panel.style.marginBottom = null;
                panel.style.marginTop = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
                panel.style.marginBottom = 60 + "px";
                panel.style.marginTop = 20 + "px";
            }
        }
    }

    const findGallerySizeSelectors = () => {
        if (!gallerySizes) {
            return;
        }
        gallerySizes.forEach(element => element.addEventListener('click', selectSizeOnProductPage));
    }

    const selectSizeOnProductPage = () => {
        const {target: clickedElement} = event;
        const selectedSize = clickedElement.dataset.size;

        Array.from(document.querySelectorAll('.is-size')).forEach(element => element.classList.remove('is-size-selected'));
        Array.from(document.querySelectorAll(`.is-size[data-size="${selectedSize}"]`)).forEach(element => element.classList.add('is-size-selected'));
    }

    const socialProductGalleryAddClickListener = () => {
        if (!document.querySelector('.product-gallery__share')) {
            return;
        }

        document.querySelector('.product-gallery__share').addEventListener('click', socialProductGalleryToggleVisibility);
    }

    const socialProductGalleryToggleVisibility = () => {
        document.querySelector('.product-gallery__socials').classList.toggle('active');
    }

    const copyToClipboardListener = () => {
        if (!document.querySelector('.copy-to-clipboard')) {
            return;
        }

        document.querySelector('.copy-to-clipboard').addEventListener('click', copyToClipboard);
    }

    const copyToClipboard = () => {
        navigator.clipboard.writeText(window.location.href).then(function () {
            console.log(`copied link: ${window.location.href}`);
        }, function (err) {
            console.error('You have no permissions to copy', err);
        });
    }

    const assistanceOverlayToggleVisibility = () => {
        if (!document.querySelector('.navigation__assistance-toggle') && !document.querySelector('.popup-assistance__close')) {
            return;
        }

        document.querySelector('.navigation__assistance-toggle').addEventListener('click', () => {
            document.querySelector('.popup-assistance').classList.add('popup-assistance--active');
            document.body.classList.add('stop-scroll');
        });

        document.querySelector('.popup-assistance__close').addEventListener('click', () => {
            document.querySelector('.popup-assistance').classList.remove('popup-assistance--active');
            document.body.classList.remove('stop-scroll');
        });

    }

    const productGalleryMore = () => {
        if (!document.querySelectorAll('.product-gallery__button-images')) {
            return;
        }
        let ctaMore = document.querySelectorAll('.product-gallery__button-images');
        ctaMore.forEach(( cta => {
          cta.addEventListener('click', function () {
            let colorImagesWrapper = cta.parentElement;
            cta.classList.add('hidden');
            colorImagesWrapper.querySelectorAll('.product-gallery__item.hidden').forEach(element => element.classList.remove('hidden'));
          });
        }));
    }

    const searchBar = () => {
        if (!document.querySelector('#searchToggle')) {
            return;
        }
        document.querySelector('#searchToggle').addEventListener('click', function (event) {
            event.preventDefault();
            document.querySelector('#searchBar').toggleAttribute('data-active')
        });
    }
    const searchBarMobile = () => {
        if (!document.querySelector('#searchToggleMobile')) {
            return;
        }
        document.querySelector('#searchToggleMobile').addEventListener('click', function (event) {
            event.preventDefault();
            document.querySelector('#searchBarMobile').toggleAttribute('data-active')
        });
    }


    window.addEventListener('scroll', function () {
        scrollNavigation();
    });

    window.addEventListener('load', function () {
        productSlider();
        document.body.classList.remove('preload');
    });

    const beforeUnloadScrollTop = () => {
        window.onbeforeunload = function () {
            window.scrollTo(0, 0, 'instant');
        }
    }

    // CALL ALL FUNCTIONS HERE
    // beforeUnloadScrollTop();
    homeMenuOverlay();
    mobileNavigationSetup();
    scrollNavigation();
    assistanceOverlayToggleVisibility();
    productGalleryDropdown();
    findGallerySizeSelectors();
    productGalleryMore();
    socialProductGalleryAddClickListener();
    copyToClipboardListener();
    searchBar();
    searchBarMobile();
})();

